export enum FormikNames {
  NATIVE_GIVEN_NAME = 'nativeGivenName',
  NATIVE_FAMILY_NAME = 'nativeFamilyName',
  BIRTH_DATE = 'birthDate',
  DOB_DAY = 'dobDay',
  DOB_MONTH = 'dobMonth',
  DOB_YEAR = 'dobYear',
  SEX = 'sex',
  NATIONALITY_CODE = 'nationalityCode',
  COUNTRY_OF_RESIDENCE_CODE = 'countryOfResidenceCode',
  EMAIL_ADDRESS = 'emailAddress',
  COMM_CONSENT_ITF = 'commConsentItf',
  COMM_CONSENT_NA = 'commConsentNa',
  HEIGHT_IN_METERS = 'heightInMeters',
  FAVOURITE_SHOT = 'favouriteShot',
  PLAYING_HAND = 'playingHand',
  DOUBLE_PLAYING_HAND = 'doublePlayingHand',
  PARENT_GUARDIAN_NAME = 'parentGuardianFullName',
  PARENT_GUARDIAN_EMAIL = 'parentGuardianEmail',
  PERSONA = 'persona',
  PERSONA_DETAIL = 'personaDetail',
  PROFILE_VISIBILITY = 'profileVisibility',
  WHERE_DID_YOU_HEAR_ABOUT_US = 'whereDidYouHearAboutUs',
  WHERE_DID_YOU_HEAR_DETAIL = 'whereDidYouHearDetail',
  WHERE_DID_YOU_HEAR_NA= 'whereDidYouHearNa',
}

export type FormikKeys = `${FormikNames}`

export type FormikValues = Partial<{ [key in FormikKeys] }>
